import React from 'react';

import ArchivedPill from 'components/ArchivedPill';
import Chip from 'components/Chip';

import { colors } from 'theme/colors';

import { HAZARD_STATUS_LABEL, HazardStatusFilter } from '../../constants';

const HazardStatusPill: React.FunctionComponent<{ archived: boolean }> = ({ archived }) =>
  archived ? (
    <ArchivedPill />
  ) : (
    <Chip
      label={HAZARD_STATUS_LABEL[HazardStatusFilter.Active]}
      size="small"
      capitalizeLabel={false}
      colors={{ background: colors.ui.status.completed, foreground: colors.common.black }}
    />
  );

export default HazardStatusPill;
